import createSvgIcon from '../Utils/CreateSvgIcon';

export const Warning = createSvgIcon(
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M12 2L10.856 4.05913L3.11111 18L2 20H4.28792L19.7121 20H22L20.8889 18L13.144 4.05913L12 2ZM12 6.11825L5.39903 18L18.601 18L12 6.11825ZM11 14V10H13V14H11ZM11 15V17H13V15H11Z"
  />,
  'Warning',
);
